import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { amountsText, formatMoney, VALUE_KINDS } from '../portfolioEconomics';
const KIND_TESTIDS = {
    deal: Testids.portfolio.deal,
    share: Testids.portfolio.share,
    bid: Testids.portfolio.bid,
    award: Testids.portfolio.award,
    revenue: Testids.portfolio.revenue
};
/**
 * One economics row. Each value kind is labeled and shown on its own; Pursuits
 * and Proposals are workload counts, not more deal value.
 */ export function EconomicsFigures({ figures, showWorkload = true }) {
    return /*#__PURE__*/ _jsxs("dl", {
        className: "grid grid-cols-2 gap-x-6 gap-y-1 text-sm sm:grid-cols-4",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("dt", {
                        className: "text-xs text-muted-foreground",
                        children: "Opportunities"
                    }),
                    /*#__PURE__*/ _jsx("dd", {
                        "data-testid": Testids.portfolio.opportunities,
                        children: figures.opportunityCount.toString()
                    })
                ]
            }),
            VALUE_KINDS.map((k)=>/*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("dt", {
                            className: "text-xs text-muted-foreground",
                            children: k.label
                        }),
                        /*#__PURE__*/ _jsx("dd", {
                            "data-testid": KIND_TESTIDS[k.key],
                            "data-amounts": amountsText(figures[k.key]),
                            children: figures[k.key].length === 0 ? 'Unknown' : figures[k.key].map((m)=>/*#__PURE__*/ _jsx("div", {
                                    children: formatMoney(m)
                                }, m.currency))
                        })
                    ]
                }, k.key)),
            showWorkload && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("dt", {
                                className: "text-xs text-muted-foreground",
                                children: "Pursuits (workload)"
                            }),
                            /*#__PURE__*/ _jsx("dd", {
                                "data-testid": Testids.portfolio.pursuits,
                                children: figures.pursuitCount.toString()
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("dt", {
                                className: "text-xs text-muted-foreground",
                                children: "Proposals (workload)"
                            }),
                            /*#__PURE__*/ _jsx("dd", {
                                "data-testid": Testids.portfolio.proposals,
                                children: figures.proposalCount.toString()
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
export function EconomicsUnavailable() {
    return /*#__PURE__*/ _jsx("p", {
        className: "text-sm text-muted-foreground",
        "data-testid": Testids.portfolio.unavailable,
        children: "Economics are unavailable to you or could not be loaded."
    });
}
